<ng-container *ngIf="cart$ | async as cart">
  <ng-container *ngIf="entries$ | async as entries">
    <div *ngIf="cart.totalItems > 0" class="cart-details-wrapper">
      <!-- Cart List for the Cart Page -->
      @if(pagetemplate === cartPageId){
      <div *ngIf="pagetemplate === cartPageId">
        <div class="cart-details-title">
          <h2>{{ 'cart.cartDetails' | cxTranslate }}</h2>
        </div>
        <div
          *ngIf="cart.totalItems == 1"
          class="cart-details-subtitle subtitle"
          [innerHtml]="'cart.cartDetailsSubtitle' | cxTranslate : { item: cart.totalItems }"
        ></div>
        <div
          *ngIf="cart.totalItems > 1"
          class="cart-details-subtitle subtitle"
          [innerHtml]="'cart.cartDetailsSubtitles' | cxTranslate : { item: cart.totalItems }"
        ></div>
        <div class="cart-actions">
          <app-cart-export [cartId]="cart.code"></app-cart-export>
          <app-cart-quick-order></app-cart-quick-order>
          <app-cart-delete [cartId]="cart.code"></app-cart-delete>
        </div>
      </div>
      <div class="collapse show" id="collapseSummary">
        <div class="error-wrapper" *ngIf="pagetemplate === cartPageId">
          <div class="default-error" *ngIf="defaultCartError">
            {{ 'cart.cartValidationError.defaultCartError' | cxTranslate }}
          </div>
          <div class="lowstock-error" *ngIf="lowStockError">
            {{ 'cart.cartValidationError.lowStockError' | cxTranslate }}
          </div>
          <div class="grey-item-error" *ngIf="unapprovedError || noStockError">
            {{ 'cart.cartValidationError.greyItemError' | cxTranslate }}
          </div>
        </div>
        <cx-cart-item-list
          [pageId]="pagetemplate"
          [cartPageId]="cartPageId"
          [items]="entries"
          [noStockError]="nostockErrorEntries"
          [lowStockError]="lowstockErrorEntries"
          [unapprovedError]="unapprovedError"
          [cartIsLoading]="!(cartLoaded$ | async)"
          [promotionLocation]="promotionLocation"
          [dateFormatted]="dateFormatted"
          [skipVariantCategory]="skipVariantCategory"
          [options]="{
            isSaveForLater: false,
            optionalBtn: isSaveForLaterEnabled() ? saveForLaterBtn : null
          }"
          [appliedPromotions]="appliedPromotions"
          [showWarehouseFeature]="showActiveSnahCountry$ | async"
        ></cx-cart-item-list>
      </div>
      }@else {
      <!-- Cart List for the Checkout Page -->
      <mat-accordion class="custom-cart-list">
        <mat-expansion-panel [expanded]="true" toggleIndicatorPosition="after">
          <mat-expansion-panel-header class="cart-details-title">
            <mat-panel-title>
              <h2 [innerHTML]="'cart.checkoutDetails' | cxTranslate : { item: cart.totalItems }"></h2>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <cx-cart-item-list
            [pageId]="pagetemplate"
            [cartPageId]="cartPageId"
            [items]="entries"
            [noStockError]="nostockErrorEntries"
            [lowStockError]="lowstockErrorEntries"
            [unapprovedError]="unapprovedError"
            [cartIsLoading]="!(cartLoaded$ | async)"
            [promotionLocation]="promotionLocation"
            [dateFormatted]="dateFormatted"
            [skipVariantCategory]="skipVariantCategory"
            [options]="{
              isSaveForLater: false,
              optionalBtn: isSaveForLaterEnabled() ? saveForLaterBtn : null
            }"
            [appliedPromotions]="appliedPromotions"
            [showWarehouseFeature]="showActiveSnahCountry$ | async"
          ></cx-cart-item-list>
        </mat-expansion-panel>
      </mat-accordion>
      }
    </div>
  </ng-container>
</ng-container>

<ng-template let-ctx #saveForLaterBtn>
  <div class="col-md-3 col-lg-3 col-xl-3 cx-sfl-btn">
    <button class="link" [disabled]="ctx.loading" (click)="saveForLater(ctx.item)">
      {{ 'saveForLaterItems.saveForLater' | cxTranslate }}
    </button>
  </div>
</ng-template>
